import * as React from "react";
import { BriefcaseBusiness } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export interface ProjectIdentityProps {
  name: string;
  cmNumber?: string | null;
  isOwner?: boolean | null;
  size?: "sm" | "md";
  className?: string;
}

const ProjectIdentity = React.forwardRef<HTMLSpanElement, ProjectIdentityProps>(
  ({ name, cmNumber, isOwner, size = "md", className }, ref) => {
    const iconSize = size === "sm" ? "size-3.5" : "size-4";
    const textSize = size === "sm" ? "text-xs" : "text-sm";

    return (
      <span ref={ref} className={cn("inline-flex min-w-0 items-center gap-2", className)}>
        <BriefcaseBusiness className={cn(iconSize, "shrink-0")} aria-hidden />
        <span className={cn("truncate font-medium", textSize)}>{name}</span>
        {cmNumber ? (
          <span className={cn("shrink-0 font-mono text-muted-foreground", size === "sm" ? "text-[10px]" : "text-xs")}>
            {cmNumber}
          </span>
        ) : null}
        {isOwner === false ? (
          <Badge variant="muted" className="shrink-0">
            Shared
          </Badge>
        ) : null}
      </span>
    );
  }
);
ProjectIdentity.displayName = "ProjectIdentity";

export { ProjectIdentity };
